<script setup lang="ts">

import { usePresentation } from '@presentation/Types/Presentation';

type Props = { src: string, title?: string }
const { src, title = 'Play Video' } = defineProps<Props>();
const presentation = usePresentation();

</script>

<template>

    <button 
        class="flex gap-4 justify-center items-center px-6 z-50
            rounded-full bg-white/10 hover:bg-white/[15%] shadow"
        @click="() => presentation.displayMedia( src )">

        <div class="rounded-full ring-[7px] ring-gray-900/50">
            <div class="
                rounded-full w-16 h-16 ring-4 ring-gray-200 text-gray-200 flex items-center justify-center
                transition-all duration-150
                bg-white/10 shadow-xl">
                <div class="absolute bottom-0 left-0 w-full h-1/2 rounded-b-full bg-gradient-to-b from-white/5 via-30% via-transparent to-transparent" />
                <Icon name="play" />
            </div>
        </div>

        <div class="tracking-wider flex text-center font-semibold uppercase">{{ title }}</div>

    </button>

</template>